import React, { useEffect, useState, useMemo } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Pagination from "../../Config/Pagination";
import { API_BASE_CRM_URL } from "../../Config/Config";
import * as XLSX from "xlsx";

import jsPDF from "jspdf";
import "jspdf-autotable";
import { Button, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useLabelContext } from "../../../Context";

const { Search } = Input;
const LeadProposal = ({ id, type }) => {
  const navigate = useNavigate();
  const customerId = id;
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const userId = userDetails?.staffid;

  const Type = "Lead";
  const [loading, setLoading] = useState(false);
  const [purchasesData, setPurchasesData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [logisticViewOBJ, setLogisticViewOBJ] = useState([]);
  const [logisticEditOBJ, setLogisticEditOBJ] = useState([]);
  const { setID } = useLabelContext();

  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");
    if (!userDetails) {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_CRM_URL}proposal/GetProposalsByRelId?RelId=${customerId}`,
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();

        if (data.Status) {
          setPurchasesData(data.ResultData);
          // console.log(data.ResultData);
        } else {
          console.error("Fetched data is not an array:", data);
          setPurchasesData([]);
        }
      } catch (error) {
        console.error("Error fetching datasssss:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleReload = () => {
    window.location.reload();
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;

  const filteredItems = useMemo(() => {
    const results = purchasesData.filter(
      (item) =>
        (item.subject &&
          item.subject.toString().includes(searchTerm.toString())) ||
        (item.company &&
          item.company.toLowerCase().includes(searchTerm.toLowerCase())),
    );

    // Reset current page if the search term changes
    setCurrentPage(1);

    return results;
  }, [purchasesData, searchTerm]);

  // Calculate indices for slicing data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const handleExcelDownload = () => {
    if (purchasesData.length === 0) {
      return; // Don't download if there is no data
    }

    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Convert your data to worksheet format
    const wsData = purchasesData.map((item) => ({
      Subject: item.subject,
      to: item.company,
      Assigne: item.staff_fullname,
      "Date ": item.date ? formatDate(item.date) : "",
      "Expiry Date": item.open_till ? formatDate(item.open_till) : "",
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "purchasesData");

    // Save the workbook to a file
    XLSX.writeFile(wb, "proposal.xlsx");
  };

  const handlePDFDownload = () => {
    const doc = new jsPDF();

    // Set properties for PDF
    doc.setProperties({
      title: "Purchase Orders",
      author: "Your Name",
      creator: "Your Application",
    });

    // Add data to PDF
    const tableData = []; // Your data array here

    // Add a header row
    const headers = [
      "Subject",
      "Related To",
      "Assigne",
      "date",
      "open_till",
      "Discount",
      "Amount",
      "Status",
    ];
    tableData.push(headers);

    // Add rows
    purchasesData.forEach((item) => {
      const row = [];
      row.push(
        item.subject,
        item.company,
        item.staff_fullname,
        item.date,
        item.open_till,
        item.rate,
      );
      tableData.push(row);
    });

    // Generate table
    doc.autoTable({
      head: [headers],
      body: tableData.slice(1),
    });

    // Save the PDF
    doc.save("proposal.pdf");
  };

  return (
    <>
      <div className="">
        <div className="d-flex justify-content-between py-1 mb-1 gap-4">
          <div className="col-8">
            <Search
              placeholder="input search text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onSearch={(value) => setSearchTerm(value)}
              enterButton={
                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  style={{
                    backgroundColor: "#FF8D1F",
                    borderColor: "#FF8D1F",
                  }}
                />
              }
            />
          </div>
          <div className="col-4 mt-1">
            <ul className="d-inline-flex list-unstyled gap-1 mb-0 justify-content-end">
              <li>
                <a
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="PDF"
                  onClick={handlePDFDownload}
                  className="btn btn-light btn-sm px-0"
                >
                  <i
                    className="fa-solid fa-file-pdf fa-2xl"
                    style={{ color: "#ff0000" }}
                  ></i>
                </a>
              </li>

              <li>
                <a
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Excel"
                  onClick={handleExcelDownload}
                  className="btn btn-light btn-sm"
                >
                  <i
                    className="fa-solid fa-file-excel fa-2xl"
                    style={{ color: "#217346" }}
                  ></i>
                </a>
              </li>

              <li>
                <Link
                  to="/add-proposal"
                  className="btn btn-sm"
                  style={{ backgroundColor: "#1B2850" }}
                  // onClick={() => setOpenNoteDrawer(true)}
                >
                  <i
                    className="fa-solid fa-plus"
                    style={{ color: "white" }}
                  ></i>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="row g-2 mb-4">
        {loading ? (
          <div className="col-12 text-center">
            <div className="containers m-auto">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
          </div>
        ) : currentItems?.length > 0 ? (
          currentItems?.map((item, index) => (
            <div key={item.id || index} className="col-12 col-md-6 col-lg-4">
              <div className="card mb-2 rounded-4">
                <div className="card-body">
                  {/* Header */}
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div>
                      {/* Badge + Subject */}
                      <Link
                        className="d-flex align-items-center gap-2 mb-1"
                        to={`/view-proposal`}
                        state={{ proposal: item }}
                      >
                        <div className="badge bg-soft-info">
                          {item.proposal_number || "PRO-20"}
                        </div>

                        <h5
                          className="mb-0 fw-bold"
                          style={{ color: "#1B2850" }}
                          title={item.subject}
                        >
                          {item.subject?.length > 20
                            ? item.subject.substring(0, 20) + "..."
                            : item.subject || "N/A"}
                        </h5>
                      </Link>

                      {/* Proposal To */}
                      <div className="d-flex align-items-center text-muted gap-5">
                        {/* Proposal To */}
                        <div className="d-flex align-items-center">
                          <i
                            className="fa-solid fa-user me-2"
                            style={{ color: "#1B2850" }}
                          ></i>
                          <span title={item.proposal_to}>
                            {item.proposal_to?.length > 20
                              ? item.proposal_to.substring(0, 20) + "..."
                              : item.proposal_to || "N/A"}
                          </span>
                        </div>

                        {/* Added By */}
                        <div className="d-flex align-items-center">
                          <i
                            className="fa-solid fa-user-plus me-2"
                            style={{ color: "#1B2850" }}
                          ></i>
                          <span title={item.AddedByName}>
                            {item.AddedByName?.length > 20
                              ? item.AddedByName.substring(0, 20) + "..."
                              : item.AddedByName || "N/A"}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Actions */}
                    <div className="dropdown">
                      <a
                        href="#"
                        className="text-dark"
                        data-bs-toggle="dropdown"
                        onClick={(e) => e.preventDefault()}
                      >
                        <i className="fa fa-ellipsis-v fs-5"></i>
                      </a>

                      <div className="dropdown-menu dropdown-menu-end">
                        <Link
                          to={`/view-proposal`}
                          state={{ proposal: item }}
                          className="dropdown-item"
                        >
                          <i className="fa-regular fa-eye me-2 text-primary"></i>
                          View
                        </Link>

                        {/* <Link
                          to={`/edit/proposal/${item.id}`}
                          className="dropdown-item"
                        >
                          <i className="fa-regular fa-pen-to-square me-2 text-info"></i>
                          Edit
                        </Link> */}
                      </div>
                    </div>
                  </div>

                  {/* Details */}
                  <div className="card-details">
                    <div className="row g-3">
                      <div className="col-4">
                        <div className="d-flex align-items-center">
                          <i
                            className="fa-solid fa-file-invoice-dollar me-2"
                            style={{ color: "#1B2850" }}
                          ></i>
                          <span>{item?.total ?? "N/A"}</span>
                        </div>
                      </div>

                      <div className="col-5">
                        <div className="d-flex align-items-center">
                          <i
                            className="fa-solid fa-calendar-days me-2"
                            style={{ color: "#1B2850" }}
                          ></i>
                          <span>
                            {item?.open_till
                              ? formatDate(item.open_till)
                              : "N/A"}
                          </span>
                        </div>
                      </div>

                      <div className="col-3">
                        {(() => {
                          switch (item.status) {
                            case 1:
                              return (
                                <span className="badge bg-outline-warning">
                                  Draft
                                </span>
                              );
                            case 2:
                              return (
                                <span className="badge bg-outline-info">
                                  Sent
                                </span>
                              );
                            case 3:
                              return (
                                <span className="badge bg-outline-danger">
                                  Declined
                                </span>
                              );
                            case 4:
                              return (
                                <span className="badge bg-outline-success">
                                  Accepted
                                </span>
                              );
                            case 5:
                              return (
                                <span className="badge bg-outline-secondary">
                                  Expired
                                </span>
                              );
                            default:
                              return (
                                <span className="badge bg-outline-dark">
                                  Unknown
                                </span>
                              );
                          }
                        })()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12 text-center text-muted">No data available</div>
        )}

        <div className="col-12">
          <Pagination
            itemsPerPage={itemsPerPage}
            totalItems={filteredItems.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        </div>
      </div>
    </>
  );
};

export default LeadProposal;
